import { server_connection } from 'config';
import store from 'store';
export const GET_SCHEDULED_COURSE_LIST      = '[SCHEDULED COURSE APP] GET SCHEDULED COURSE LIST';
export const GET_SCHEDULED_COURSE_DATA      = '[SCHEDULED COURSE APP] GET SCHEDULED COURSE DATA';
export const GET_SCHEDULED_COURSE           = '[SCHEDULED COURSE APP] GET SCHEDULED COURSE';
export const UPDATE_SCHEDULED_COURSE_LOADED = '[SCHEDULED COURSE APP] UPDATE SCHEDULED COURSE_LOADED';
export const GET_RELATED_DATA               = '[SCHEDULED COURSE APP] GET RELATED DATA';
export const UPDATE_SCHEDULED_COURSE_FORM   = '[SCHEDULED COURSE APP] UPDATE SCHEDULED COURSE FORM';
export const TOGGLE_INSTRUCTOR              = '[SCHEDULED COURSE APP] TOGGLE INSTRUCTOR';
export const TOGGLE_STUDENT                 = '[SCHEDULED COURSE APP] TOGGLE STUDENT';
export const TOGGLE_PRIMARY_INSTRUCTOR      = '[SCHEDULED COURSE APP] TOGGLE PRIMARY INSTRUCTOR';

export const GET_SCHEDULED_COURSE_SCHEDULE  = '[SCHEDULED COURSE APP] GET SCHEDULED COURSE SCHEDULE';
export const GET_DAY_EVENTS                 = '[SCHEDULED COURSE APP] GET DAY EVENTS';
export const GET_AGENDA                     = '[SCHEDULED COURSE APP] GET AGENDA';
export const GET_NOTIFICATIONS              = '[SCHEDULED COURSE APP] GET NOTIFICATIONS';
export const GET_STUDENT_PROGRESS           = '[SCHEDULED COURSE APP] GET STUDENT PROGRESS';

export function updateScheduledCourseLoaded(setting) {
    return {
        type: UPDATE_SCHEDULED_COURSE_LOADED,
        payload: setting
    }
}

export function updateScheduledCourseForm(scheduled_course_data) {
    return {
        type: UPDATE_SCHEDULED_COURSE_FORM,
        payload: scheduled_course_data
    }
}

export function getScheduledCourse(scheduled_course_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/scheduled_course/get/' + scheduled_course_id)
            .then((response) => response.json())
            .then((scheduledCourseData) => {
                dispatch({
                    type: GET_SCHEDULED_COURSE,
                    payload: scheduledCourseData,
                });
            });
    }
}

export function getScheduledCourseData(scheduled_course_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getScheduledCourse(scheduled_course_id)),
            dispatch(getRelatedData(scheduled_course_id)),
            dispatch(getCompanyCourseSchedule(scheduled_course_id)),
            dispatch(getNotifications(scheduled_course_id))
        ]).then(
            () => dispatch(updateScheduledCourseLoaded(true))
        )
    }
}

export function getScheduledCourseList() {
    const auth_id = store.getState().auth.user.data.auth_id
    return (dispatch, getState) => {
        fetch(server_connection + '/scheduled_course/list/' + auth_id)
            .then((response) => response.json())
            .then((scheduledCourseList) => {
                dispatch({
                    type: GET_SCHEDULED_COURSE_LIST,
                    payload: scheduledCourseList,
                });
            });
    }
}

export function getRelatedData(scheduled_course_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/scheduled_course/data/' + scheduled_course_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_RELATED_DATA,
                    payload: data
                })
            })
    }
}

export function toggleInstructor(instructor, action_type) {
    return {
        type: TOGGLE_INSTRUCTOR,
        payload: { instructor: instructor, action_type: action_type }
    }
}

export function toggleStudent(student, action_type) {
    return {
        type: TOGGLE_STUDENT,
        payload: { student: student, action_type: action_type }
    }
}

export function saveScheduledCourse(scheduledCourse, students, instructors) {
    const auth_id = store.getState().auth.user.data.auth_id
    return async (dispatch, getState) => {
        await fetch(server_connection + '/scheduled_course/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    scheduledCourse: scheduledCourse,
                    students: students,
                    instructors: instructors,
                    auth_id
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getScheduledCourseList())
            })
    }
}

export function getCompanyCourseSchedule(company_course_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/scheduled_course/schedule/' + company_course_id)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_SCHEDULED_COURSE_SCHEDULE,
                    payload: events
                })
            })
    }
}

export function getDayEvents(company_course_id, toggleDate) {
    return async (dispatch) => {
        return await fetch(server_connection + '/scheduled_course/schedule/day_events/' + company_course_id + '/' + toggleDate)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_DAY_EVENTS,
                    payload: events
                })
            })
    }
}

export function getAgenda(company_course_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/scheduled_course/schedule/agenda/' + company_course_id)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_AGENDA,
                    payload: events
                })
            })
    }
}

export function togglePrimaryInstructor(instructor_id, value) {
    return {
        type: TOGGLE_PRIMARY_INSTRUCTOR,
        payload: { instructor_id, value }
    }
}

export function getNotifications(company_course_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/scheduled_course/notifications/' + company_course_id + '/null') 
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_NOTIFICATIONS,
                    payload: data
                })
            })
    }
}

export function getStudentProgress(scheduled_course_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/scheduled_course/student_progress/' + scheduled_course_id) 
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_STUDENT_PROGRESS,
                    payload: data
                })
            })
    }
}




// WEBPACK FOOTER //
// src/main/content/scheduled_course/store/actions/scheduled_course.actions.js